export default "__VITE_ASSET__CmUiCfP2__"